import React, { useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import GiftModal from './GiftModal';

const GiftButton = ({ 
  toUserId, 
  toUserName, 
  context = 'PERSONAL', 
  relatedId = null, 
  relatedType = null,
  className = "",
  variant = 'default' // 'default', 'small', 'icon'
}) => {
  const { currentUser } = useAuth();
  const [showModal, setShowModal] = useState(false);

  // ตรวจสอบว่าไม่ใช่ตัวเอง
  const isSelf = currentUser && currentUser.uid === toUserId;

  if (isSelf) return null;

  const buttonClasses = {
    default: "flex items-center space-x-2 bg-gradient-to-r from-pink-500 to-purple-600 text-white px-4 py-2 rounded-lg hover:from-pink-600 hover:to-purple-700 transition-all transform hover:scale-105 shadow-lg",
    small: "flex items-center space-x-1 bg-pink-500 text-white px-3 py-1 rounded-lg hover:bg-pink-600 transition-colors text-sm",
    icon: "p-2 bg-pink-500 text-white rounded-full hover:bg-pink-600 transition-colors"
  };

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className={`${buttonClasses[variant]} ${className}`}
      >
        <span className="text-lg">🎁</span>
        {variant !== 'icon' && (
          <span className="font-medium">ให้ของขวัญ</span>
        )}
      </button>

      <GiftModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        toUserId={toUserId}
        toUserName={toUserName}
        context={context}
        relatedId={relatedId}
        relatedType={relatedType}
      />
    </>
  );
};

export default GiftButton;

